import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetSession = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null,type =null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['price'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }

    if (type) {
        params['type'] = type;
    }
    if(is_paginate === 1){
        params['paginate'] = is_paginate;

    }

    const response = await GET(apiUrl.session, params);
    return response;
}

export const GetSessionById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.session + '/' + id,params);
    return response;
}

export const CreateSession = async (data) => {
    const response = await POST(apiUrl.session, data);
    return response;
}

export const UpdateSession = async (id, data) => {
    const response = await PUT(apiUrl.session, id, data);
    return response;
}

export const DeleteSession = async (id) => {
    const response = await DELETE(apiUrl.session, id);
    return response;
}
